import { API } from "./axios.service";
export class OndcService {
  static async getOndcIgmData(data: any): Promise<any> {
    return API.get(`/ondc/issue`, { params: data });
  }

  static async updateOndcIgmData(data: any): Promise<any> {
    return API.post(`/ondc/respond_issue`, data);
  }

  static async updateNeedMoreInfo(data: any): Promise<any> {
    return API.post(`/ondc/respond_issue_need_info`, data);
  }
  static async sendIssueResolutions(data: any): Promise<any> {
    return API.post(`/ondc/send_issue_resolutions`, data);
  }

  static async resolveIssue(data: any): Promise<any> {
    return API.post(`/ondc/resolve_issue`, data);
  }

  static async getOndcOrders(data: any): Promise<any> {
    return API.get(`/ondc/ondc-orders`, { params: data });
  }
}
